import { List, Stack } from '@mantine/core'
import LoadingSkeleton from '@v2/commons/components/LoadingSkeletonRows/LoadingSkeletonRows.component'
import { removeUnderScoreAndTransformToLowerCase } from '@v2/commons/utils/stringManipulation'
import { getLeadStatusColor } from '@v2/domains/person/utils'
import { DataTable } from 'mantine-datatable'

import useAssociatedInformation from '../hooks/useAssociatedInformation.hook'
import { getTableHeaders } from '../utils/TableHeaderRenderer.util'
import styles from './data-table.module.scss'

const AssociatedInformation = () => {
  const { data: datafields } = useAssociatedInformation()

  const tableColumns = getTableHeaders(datafields)

  return !!datafields.length ? (
    <DataTable
      style={{ zIndex: 0 }}
      height={'50vh'}
      pinFirstColumn
      withColumnBorders
      idAccessor="field"
      fz="16px"
      key="field"
      records={datafields}
      defaultColumnProps={{
        titleClassName: styles['column-title'],
        width: '200px',
        textAlign: 'center',
        cellsStyle: ({ field }) =>
          field === 'Chat'
            ? (theme) => ({ fontStyle: 'italic', color: theme.colors.red[6] })
            : { verticalAlign: 'baseline' },
      }}
      defaultColumnRender={(row, _idx, accessor) => {
        const data = row[accessor as keyof typeof row]

        return (
          <>
            {Array.isArray(data) ? (
              <List
                type="ordered"
                size="md"
                tt="capitalize"
                ta="start"
                maw="180px"
                spacing="xs"
              >
                {data.map((value: any) =>
                  row.field === 'associatedBenefitContract' ? (
                    <List.Item key={value.name + value.status}>
                      {value.name}
                      <br />
                      <span
                        style={{
                          color: getLeadStatusColor(
                            removeUnderScoreAndTransformToLowerCase(
                              value.status,
                            ),
                          ),
                        }}
                      >
                        {removeUnderScoreAndTransformToLowerCase(value.status)}
                      </span>
                    </List.Item>
                  ) : row.field === 'tags' ? (
                    value.name && (
                      <List.Item key={value.name}>{value.name}</List.Item>
                    )
                  ) : (
                    <>
                      {value.type && (
                        <List.Item key={value.number}>
                          {removeUnderScoreAndTransformToLowerCase(value.type)}
                          <br />#{value.number}
                        </List.Item>
                      )}
                    </>
                  ),
                )}
              </List>
            ) : (
              (data as string)
            )}
          </>
        )
      }}
      columns={[
        {
          accessor: 'field',
          title: '',
          titleStyle: { backgroundColor: 'white' },
          cellsClassName: styles['column-cell-field'],
          textAlign: 'left',
        },
        {
          accessor: 'total',
          title: 'Merged Record',
          titleClassName: styles['sticky-column'],
          cellsClassName: styles['sticky-cell'],
        },
        ...tableColumns,
      ]}
    />
  ) : (
    <LoadingSkeleton
      stackProps={{
        justify: 'space-between',
        h: '30vh',
      }}
      maxRange={10}
      height={'10%'}
      radius="sm"
    />
  )
}

export default AssociatedInformation
